import { ScrollView, Text } from 'react-native'

export default function Page() {
  return (
    <ScrollView contentInsetAdjustmentBehavior="automatic">
      <Text>账户详情</Text>
    </ScrollView>
  )
}
